import React, { useMemo } from "react";
import "./avatar.css";

const LettersAvatar = ({ firstName, lastName, imageSrc, width, height }) => {
  const firstNameInitial = firstName?.[0] ? firstName[0].toUpperCase() : "";
  const lastNameInitial = lastName?.[0] ? lastName[0].toUpperCase() : "";
  const getRandomColor = useMemo(() => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 15)];
    }
    return color !== "#000000" ? color : getRandomColor();
  }, []);

  const avatarStyle = {
    backgroundColor: getRandomColor,
    color: "#ffffff",
    fontSize: "30px",
  };

  return (
    <div className="bg-white p-2 rounded">
      {imageSrc ? (
        <img
          src={imageSrc}
          height={55}
          width={55}
          alt={`${firstName} ${lastName}`}
          className="avatar-image rounded"
        />
      ) : (
        <>
          <div style={avatarStyle}>{firstNameInitial}</div>
          <div style={avatarStyle}>{lastNameInitial}</div>
        </>
      )}
    </div>
  );
};

export default LettersAvatar;
